$(document).on('moreJS:ready', function(){
	'use strict';
	
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const wfId = parseInt(urlParams.get('wf'));
	
//	if($('#copyworkflow').length){
	if(wfId !== null){
		// make sure sweetalert is loaded first, it's needed for the confirmation check
		$.loadSweetalertJs(async function () {
//			let wfId = parseInt(new URL(location.href).searchParams.get('wfid'));
		
			if(!Number.isNaN(wfId)){
				// check local storage for the given wfId
				let storedWfIds = JSON.parse(localStorage.getItem('activeWfCopies')) || {};

				// check if wfId is in storedWfIds
				// user needs to confirm a new copy if needed
				if(wfId in storedWfIds){
					
					// ask user if they want to continue with the existing workflow
					await Swal.fire({
						title: $.i81n.text('WF_CONFIRM_NEW_COPY_HEADER'),
						text: $.i81n.text('WF_CONFIRM_NEW_COPY_INFO'),
						icon: 'question',
						showCancelButton: true,
						confirmButtonText: $.i81n.text('YES'),
						cancelButtonText: $.i81n.text('NO'),
						allowOutsideClick: false
					}).then(result => {
						if(result.value){
							// redirect to existing workflow
							window.location.href = '/api/v1/wf/' + storedWfIds[wfId];
							return;
						}else if(result.isDismissed){
							fetch('/api/v1/wf/cancel/' + storedWfIds[wfId], {
								method: "POST",
								headers: {"Content-Type": "application/json"}
							});
						}
					});
				}
				
				fetch('/api/v1/wf/new/' + wfId, {
					method: "POST",
					headers: {"Content-Type": "application/json"}
				})
					.then(response => response.json())
					.then(result => {
						const code = result.code;
						switch (code) {
							case 201:
								// write to local storage
								storedWfIds[wfId] = result.key;
								localStorage.setItem('activeWfCopies', JSON.stringify(storedWfIds));

								window.location.href = '/api/v1/wf/' + result.key;
								break;
							case 404:
								
								
								break;
							case 403:

								
								throw 'Unauthorized';
								break;
						}

					})
					.catch(error => console.error(error));
			}
		});
	}
});